import { render, staticRenderFns } from "./CreateAccountMagayaInputs.vue?vue&type=template&id=4acb434d&scoped=true"
import script from "./CreateAccountMagayaInputs.vue?vue&type=script&lang=js"
export * from "./CreateAccountMagayaInputs.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountMagayaInputs.vue?vue&type=style&index=0&id=4acb434d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb434d",
  null
  
)

export default component.exports